"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rcSlider = _interopRequireWildcard(require("rc-slider"));

var _rcSlider2 = _interopRequireDefault(require("./rc-slider"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledSlider = _styledComponents["default"].div.withConfig({
  displayName: "component__StyledSlider",
  componentId: "sc-1d0g5uz-0"
})(["width:100%;.slider{position:relative;height:4px;width:100%;background:", ";}", ""], function (props) {
  return props.theme.slider.track;
}, _rcSlider2["default"]);

var Slider = function Slider(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 1 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 500 : _ref$max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      theme = _ref.theme,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onDone = _ref.onDone,
      onDone = _ref$onDone === void 0 ? function () {} : _ref$onDone;
  var isRange = Array.isArray(value);
  return _react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, _react["default"].createElement(StyledSlider, null, isRange && _react["default"].createElement(_rcSlider.Range, {
    value: value,
    step: step,
    min: min,
    max: max,
    handleStyle: {
      width: "20px",
      height: "20px",
      top: "2px"
    },
    onChange: onChange,
    onDone: onDone
  }), !isRange && _react["default"].createElement(_rcSlider["default"], {
    onAfterChange: onDone,
    onChange: onChange,
    handleStyle: {
      width: "20px",
      height: "20px",
      top: "2px"
    },
    value: value,
    step: step,
    max: max,
    min: min
  })));
};

var _default = Slider;
exports["default"] = _default;